/**
 * @generated SignedSource<<f31bd592a4fcead075ae4fa50a816423>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteProjectConfirmationModal_designProject$data = {
  readonly name: string | null;
  readonly serviceId: string | null;
  readonly status: string | null;
  readonly " $fragmentType": "DeleteProjectConfirmationModal_designProject";
};
export type DeleteProjectConfirmationModal_designProject$key = {
  readonly " $data"?: DeleteProjectConfirmationModal_designProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteProjectConfirmationModal_designProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteProjectConfirmationModal_designProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "designProject",
  "abstractKey": null
};

(node as any).hash = "8f7424f81ae823326929380be1efbe22";

export default node;
